import React from 'react';
import {makeStyles} from 'tss-react/mui';
import useMediaQuery from '@mui/material/useMediaQuery';
import breakpoints from 'wobi-web-common/dist/config/breakpoints';

const useStyles = makeStyles()((theme) => ({
  appRoot: {
    background: `linear-gradient(180deg, ${theme.palette.travel.pageBackground.start} 0%, ${theme.palette.travel.pageBackground.end} 100%)`,
    minHeight: '100vh',
    overflowX: 'clip',
    position: 'relative',
    '&.offers .main-content': {
      paddingTop: 0,
    },
    '&.offers .bottom': {
      paddingInline: 0,
    },
  },
  inner: {
    minHeight: '100vh',
    position: 'relative',
    '& > :not(.dest-bg):not(header)': {
      position: 'relative',
      zIndex: 1,
    },
    '&.mobile': {
      '& .bottom': {
        padding: 0,
      },
    },
    '& .bottom': {
      padding: '0px 74px 50px 74px',
    },
    '& .main-content': {
      padding: '34px 0',
    },
  },
}));

const MainContainer = ({children, variant}) => {
  const {classes} = useStyles();
  const isMobile = useMediaQuery(`(max-width:${breakpoints.mobile}px)`);

  return (
    <div className={`App ${classes.appRoot} ${variant || ''}`} data-testid='app-root-container'>
      <div className={`${classes.inner} ${isMobile ? 'mobile' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default MainContainer;
